import { render, staticRenderFns } from "./ModeratorActionCell.vue?vue&type=template&id=7d4a464f&scoped=true&"
import script from "./ModeratorActionCell.vue?vue&type=script&lang=babel&"
export * from "./ModeratorActionCell.vue?vue&type=script&lang=babel&"
import style0 from "./ModeratorActionCell.vue?vue&type=style&index=0&id=7d4a464f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a464f",
  null
  
)

export default component.exports